<oaibox-warning-message-card gradient="danger" confirmText="Delete" (confirm$)="deleteUser()" (cancel$)="cancel()">
  <div messageTitle>Are you sure you want to delete this user?</div>
  <div messageBody class="content">
    <oaibox-user-row [user]="user" [tenant]="tenant"></oaibox-user-row>
  </div>
</oaibox-warning-message-card>